import axios from '@/plugins/axios'

/**
 * SILL-1533 (CUEST02.2) — Cuestionario de falla del equipo.
 *
 * Los 2 primeros endpoints son públicos (el cliente los abre desde el link del
 * correo, sin login) y quedan protegidos por el token UUID del formulario. El
 * tercero es el de Center y va con el token del usuario autenticado.
 */

const authConfig = () => {
  const { key } = JSON.parse(localStorage.getItem('user') || '{}')
  return { headers: { Authorization: `Token ${key}` } }
}

/**
 * Estado del cuestionario y preguntas por responder.
 * @param {string} token UUID del formulario (viene en el link del correo)
 * @returns {Promise<{ot: number, completado: boolean, completado_en: string|null, preguntas: Array}>}
 */
export const obtenerFormularioPublico = (token) =>
  axios.get(`api/orden/formulario-falla/${token}/`).then((r) => r.data)

/**
 * Envía las respuestas del cliente.
 * @param {string} token UUID del formulario
 * @param {Array<{pregunta: number, valor: string|string[]}>} respuestas
 */
export const responderFormulario = (token, respuestas) =>
  axios
    .post(`api/orden/formulario-falla/${token}/responder/`, { respuestas })
    .then((r) => r.data)

/**
 * Respuestas ya enviadas, para el detalle de la OT en Center.
 * @param {number} otId
 */
export const obtenerRespuestasOT = (otId) =>
  axios
    .get(`api/orden/${otId}/formulario-falla/`, authConfig())
    .then((r) => r.data)

export default {
  obtenerFormularioPublico,
  responderFormulario,
  obtenerRespuestasOT,
}
